// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import type { SearchCSS } from '../theme';
import { ClearIconWrapper } from './clear-icon-wrapper';
import type { IsExpandedProp } from './search-input.styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import type { Theme } from '@emotion/react';
import type { ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedClearIconWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS &
		ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> & {
			theme?: Theme;
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
		} & IsExpandedProp,
	{},
	{}
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(ClearIconWrapper)<SearchCSS & IsExpandedProp>`
	width: ${token('space.300')};
	height: ${token('space.300')};
	padding-top: 0;
	padding-bottom: 0;
	padding-left: ${({ isExpanded }) => (isExpanded ? `${token('space.150')}` : '0')};
	padding-right: ${({ isExpanded }) => (isExpanded ? `${token('space.200')}` : '2px')};
	color: ${token('color.text.subtle')};
`;
